// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"2276e224","123":"7386821b","808":"4a5cd122"}[chunkId] + ".css";
};